export const version: string = '0.2.6';
